import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import CreatableSelect from 'react-select/creatable';
import isEmpty from 'lodash/isEmpty';
import { ThemeContext } from 'Context';
import { Wrapper, dropdownStyle, PlusIcon } from './styled';

export const CustomIcon = () => {
  return (
    <PlusIcon />
  );
};

const Input = ({ tagsAvailable, tags, setTags }) => {
  const { themeStyles } = useContext(ThemeContext);
  const intl = useIntl();
  const tagsOptions = isEmpty(tags) ? tagsAvailable.map((t) => ({ label: t.name, value: t })) : tagsAvailable.filter(el => !tags.some(t => t.id === el.id)).map((t) => ({ label: t.name, value: t }));
  const [selectedOption, setSelectedOption] = useState('');
  const placeholder = intl.formatMessage({ id: 'agents.detail.tags.placeholder' });

  const onSelectHandler = (item, actionMeta) => {
    setSelectedOption(item);
    if (actionMeta?.action === 'select-option') {
      if (isEmpty(tags)) setTags([item.value], item.value);
      else setTags([...tags, item.value], item.value);
    }
    if (actionMeta?.action === 'create-option') {
      if (isEmpty(tags)) setTags([item.value], item.value);
      else setTags([...tags, item.value], item.value);
    }
  };

  const isValidNewOption = (inputValue) => {
    return inputValue?.trim()?.length > 0;
  };

  return (
    <Wrapper>
      <CreatableSelect
        value={ selectedOption }
        onChange={ onSelectHandler }
        options={ tagsOptions }
        controlShouldRenderValue={ false }
        placeholder={ placeholder }
        styles={ dropdownStyle(themeStyles) }
        components={ { DropdownIndicator: CustomIcon } }
        isValidNewOption={ isValidNewOption }
      />
    </Wrapper>
  );
};

export default Input;
